<template>
  <div>
    <div class="hit-input-group">
      <div class="hit-input-group-addon">
        <hit_icon :id="'lock'" />
      </div>
      <input type="text"  class="hit-form-control" v-model="data" v-on:change="change()" v-bind:placeholder="$t('message.add',{name: $t('message.password')})">
    </div>
  </div>
</template>

<script>

export default{
  props: { edit: Object},
  data () {
    return {
      data: this.$store.getters.boards[this.edit.row].pass
    }
  },
  methods: {
    change () {
      this.$store.dispatch('set_change_board', {index: this.edit.row, data: {pass: this.data} })
    }
  }
}
</script>
